module.exports = __webpack_public_path__ + "resources/3596833b8852b6ea37b94e4f6b572e5b.otf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/CompactaBT-Roman.otf
// module id = 218
// module chunks = 0